<section class="pb-7">
  @if (filters(); as filters) {
    <div class="desk:centered-with-padding no-scrollbar flex w-screen overflow-x-auto px-5 pb-7">
      <app-filter-toggle-group [filters]="filters" [filterName]="filterName" />
    </div>
  }
  @if (countertops(); as countertops) {
    <div class="centered-with-padding grid grid-cols-1 gap-y-6 desk:grid-cols-4 desk:gap-5">
      @for (countertop of countertops; track $index) {
        @if ($index === 4) {
          <div class="desk:hidden">
            <ng-container *ngTemplateOutlet="breathingText" />
          </div>
        }
        @if ($index === 6) {
          <div class="hidden desk:col-span-2 desk:block">
            <ng-container *ngTemplateOutlet="breathingText" />
          </div>
        }
        <div class="h-[342px]">
          <app-option-card
            (imageClicked)="openVisualFullScreenModal(countertop.image)"
            [image]="countertop.image"
            imageCursorType="zoomIn">
            <div card-title-left>{{ countertop.title }}</div>
            <div card-description>{{ countertop.dimensions }}</div>
          </app-option-card>
        </div>
      }
    </div>
  } @else {
    <app-grid-skeleton
      gridClass="centered-with-padding grid grid-cols-1 gap-y-6 desk:grid-cols-4 desk:gap-5"
      itemClass="h-[342px]"
      [count]="6" />
  }
</section>

<ng-template #breathingText>
  <div class="flex size-full items-center justify-center py-8 desk:p-6">
    <app-title [title]="{ text: data.breathingText, as: 'span' }" size="h2" />
  </div>
</ng-template>
